import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ProLayout from "@ant-design/pro-layout";
import Footer from "components/Footer";
import routesConfig from "./menu";
import LogoImage from "assets/logo.svg";
import SystemInfo from "components/SystemInfo";
import RouteMap from "components/route/RouteMap";
import HeaderContent from "./components/HeaderContent";
import UserDropdown from "./components/navbar/UserDropDown";

import ROUTES from "./routes";

import "@ant-design/pro-table/dist/table.min.css";
import "@ant-design/pro-layout/dist/layout.min.css";
import "@ant-design/pro-form/dist/form.min.css";
import "@ant-design/pro-card/dist/card.min.css";
import "components/MenuFix.css";

const AdminView: React.FC<any> = () => {
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  // 根据当前路径自动展开对应的菜单
  React.useEffect(() => {
    const currentPath = location.pathname;
    let keysToOpen: string[] = [];
    
    if (currentPath.includes('/admin/')) {
      if (currentPath.includes('/stations')) {
        keysToOpen.push('/admin/stations');
      } else if (currentPath.includes('/device-types')) {
        keysToOpen.push('/admin/device-types');
      }
    }
    
    setOpenKeys(keysToOpen);
  }, [location.pathname]);
  
  // 自定义菜单项渲染，处理一级菜单点击
  const handleMenuItemClick = (item: any) => {
    // 如果有路径则导航，否则只是展开/折叠
    if (item.path) {
      return <Link to={item.path}>{item.name}</Link>;
    }
    return item.name;
  };
  
  return (
    <ProLayout
      headerContentRender={() => <HeaderContent />}
      title="LRMS"
      logo={LogoImage}
      location={location}
      fixSiderbar
      fixedHeader
      links={SystemInfo}
      route={routesConfig}
      menuItemRender={(item, dom) => {
        // 如果没有路径但有子菜单，保持原有展开/折叠行为
        if (!item.path && item.routes && item.routes.length > 0) {
          return dom;
        }
        // 如果有路径，则包装为链接
        if (item.path) {
          return <Link to={item.path}>{dom}</Link>;
        }
        // 其他情况直接返回dom
        return dom;
      }}
      selectedKeys={[location.pathname]}
      rightContentRender={() => <UserDropdown />}
      footerRender={() => <Footer />}
      openKeys={openKeys}
      onOpenChange={(keys: string[] | false) => {
        // 根据当前路径智能展开对应的菜单
        const currentPath = location.pathname;
        let newKeys = keys || [];
        
        // 如果当前路径是某个二级菜单项，确保其父菜单展开
        if (currentPath.includes('/admin/')) {
          if (currentPath.includes('/stations')) {
            if (!newKeys.includes('/admin/stations')) {
              newKeys.push('/admin/stations');
            }
          } else if (currentPath.includes('/device-types')) {
            if (!newKeys.includes('/admin/device-types')) {
              newKeys.push('/admin/device-types');
            }
          }
        }
        
        setOpenKeys(newKeys);
      }}
    >
      <RouteMap config={ROUTES} />
    </ProLayout>
  );
};

export default AdminView;
